import React from 'react'
import DataItem from './DataItem'

function renderItems (items) {
  return items.length > 0 && items.map((item, i) => {
    return <DataItem {...item} key={i} />
  })
}

export default function DataItems (props) {
  return (
    <div className='mtt-ttmzero-circle__data-items'>
      {renderItems(props.items)}
    </div>
  )
}
